<div class="inline-flex flex-row items-center wrapper field-container">
  <div class="control prev" (click)="onValueChange(value - 1)">-</div>
  <div class="input w-[100px]">
    <input nz-input type="number" class="text-center" [min]="min" [(ngModel)]="value" (blur)="onValueChange(value)" />
  </div>
  <div class="control next" (click)="onValueChange(value + 1)">+</div>
</div>
